export default __webpack_public_path__ + "static/media/restaumatic-sm.14044e3e.svg";